import React, { FC } from "react";

interface TrainerProps {
    name: string;
    photo: string;
    instagram: string,
}

const Trainer: FC<TrainerProps> = ({ name, photo, instagram }) => {
    return (
        <div className="trainer">
            <div className="trainer__image">
                <img src={photo} alt="trainer" />
            </div>
            <div className="trainer__info">
                <p>Trainer {name}</p>

                {/* instagram */}
                <a
                    href={instagram}
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        width="40"
                        height="40"
                        src="https://img.icons8.com/material-outlined/48/ffffff/instagram-new--v1.png"
                        alt="instagram-new--v1"
                    />
                </a>
            </div>
        </div>
    );
};

export default Trainer;
